import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import toast from 'react-hot-toast'
import { PnsMacMiniUserStatus, WispStatus } from 'interfaces/pns-mac-mini-user'

interface UpdateMacMiniUserParams {
  userId: string
  status?: PnsMacMiniUserStatus
  wispStatus?: WispStatus
  wispPort?: number
  serviceFqdn?: string
}

const updateMacMiniUser = async ({
  userId,
  ...updateData
}: UpdateMacMiniUserParams) => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/mac_mini_users/${userId}`,
    {
      method: API_METHODS.PUT,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify(updateData),
    }
  )

  response = handleErrors(response)

  return response.json()
}

const useUpdateMacMiniUserFull = () => {
  const queryClient = useQueryClient()

  return useMutation(updateMacMiniUser, {
    onError: (error: Error) => {
      console.error('Failed to update Mac Mini user:', error)
      toast.error(`Failed to update Mac Mini user: ${error.message}`)
    },
    onSuccess: (data, variables) => {
      toast.success('Mac Mini user updated successfully')

      // Invalidate related queries
      queryClient.invalidateQueries(['mac-mini-user-by-phone'])
      queryClient.invalidateQueries(['mac-mini-users'])
      queryClient.invalidateQueries(['mac-mini-detail'])
      queryClient.invalidateQueries(['mac-mini-user-detail'])
    },
  })
}

export default useUpdateMacMiniUserFull
